import { FunctionComponent, useMemo } from 'react';
import { I18nextProvider } from 'react-i18next';
import {
    VouchersOverviewContainerProps,
    VouchersOverviewContainer,
} from './vouchersOverviewUIContainer';
import { initI18nNextVoucherOverview } from '../lib/i18n/initI18n';

type VouchersOverviewUIProps = {
    locale?: string;

    translations?: {
        en?: Record<string, string>;
        de?: Record<string, string>;
    };
} & VouchersOverviewContainerProps;

export const VouchersOverviewUI: FunctionComponent<VouchersOverviewUIProps> = ({
    locale = 'de',
    translations,
    ...props
}) => {
    const i18n = useMemo(
        () =>
            initI18nNextVoucherOverview({
                lng: locale,
                translations,
            }),
        []
    );

    if (locale !== i18n.language) {
        i18n.changeLanguage(locale);
    }

    return (
        <I18nextProvider i18n={i18n}>
            <VouchersOverviewContainer {...props} />
        </I18nextProvider>
    );
};
